<div class="grid">
  <div class="col-12">
    <div class="ml-2 mt-2 mb-2">
    </div>
    <div class="flex justify-content-start ml-2">
      <div class="flex flex-column gap-1">
        <div><i class="pi pi-bullseye icon"></i> Membership: {{membership?.Description}}</div>
      </div>
    </div>
  </div>
</div>
<div class="text-right text-2xl font-semibold pr-3">Sub Total: {{totals.items | currency}}</div>
<div class="text-right text-2xl font-semibold pr-3">Tax: {{totals.tax | currency}}</div>
<p-divider></p-divider>
<div class="text-right text-3xl font-semibold pr-3 mb-2">Total: {{totals.total | currency}}</div>
<div class="text-right text-3xl font-semibold pr-3">
  <p-button (onClick)="onCompleteClick()" [loading]="isProcessing" [disabled]="isProcessing" label="CHECKOUT"></p-button>
</div>
<p-dialog header="Error" [(visible)]="showError">
  <p>
    Your payment was declined.
  </p>
</p-dialog>